
import WCAG from '@/scripts/libs/wcag/wcag'
export default {
  props: {
    cover: {
      type: String,
      default: '',
    },
    coverMobile: {
      type: String,
      default: '',
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    controlsPositionClass: {
      type: String,
      default: 'rb-editorial__video-controllers--bottom-left',
    },
    videoName: {
      type: String,
      default: '',
    },
    videoText: {
      type: String,
      default: '',
    },
    audioTogglesEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMuted: this.$props.muted,
      playing: false,
      hasVideoAlreadyBeenPlayed: false,
    }
  },

  mounted() {
    if (this.autoplay) {
      this.play()
    }
  },
  methods: {
    onPlayKeypress(e) {
      if (WCAG.isEnterPressed(e)) {
        this.play()
      }
    },
    onPauseKeypress(e) {
      if (WCAG.isEnterPressed(e)) {
        this.pause()
      }
    },
    onToggleAudioKeypress(e) {
      if (WCAG.isEnterPressed(e)) {
        this.toggleAudio()
      }
    },
    canVideoPlay() {
      if (this.loop) {
        return true
      } else {
        return !this.hasVideoAlreadyBeenPlayed
      }
    },
    viewHandler(e) {
      if (this.autoplay) {
        const isVideoInsideViewport = e.percentInView === 1
        if (isVideoInsideViewport) {
          if (!this.playing && this.canVideoPlay()) {
            this.play()
          }
        } else if (this.playing) {
          this.hasVideoAlreadyBeenPlayed = true
          this.pause()
        }
      }
    },
    toggleAudio(event) {
      event.stopPropagation()
      this.$refs.video.isMuted = !this.$refs.video.isMuted
      this.isMuted = this.$refs.video && this.$refs.video.isMuted
    },
    pause(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.$refs.video?.pause()
      this.playing = false
    },
    play(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.$refs.video?.play()
      this.playing = true
    },
  },

  render() {
    return this.$slots.default
  },
}
